"use strict";

(function () {
  'use strict';

  angular.module('lr.reserve.payment-summary', []).component('lrReservePaymentSummary', {
    bindings: {
      transaction: '=',
      loading: '<'
    },
    templateUrl: 'components/lr.reserve.payment-summary/lr.reserve.payment-summary.html'
  });
})();